var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { buildFullUrl } from '../../backend/features/logi-reports/shared';
import { getToken } from '../../ui/utils';
import { themeMode } from '@juvare/common-web-ui/JuvareTheme';
import { usePublicDataGet } from '@juvare/platform-sdk-react/ui/hooks';
export function useLogiConfig() {
    const _a = usePublicDataGet('logi-config'), { data } = _a, rest = __rest(_a, ["data"]);
    return {
        isLoading: rest.isLoading,
        error: rest.error,
        mutate: () => {
            throw new Error('not supported');
        },
        isValidating: rest.isValidating,
        data: data
            ? {
                componentConfig: {
                    theme: themeMode === 'dark' ? 'dark' : 'composer',
                },
                getToken: getToken,
                logiBaseUrl: buildFullUrl(new URL(window.location.href).origin, data.logiUrl),
            }
            : undefined,
    };
}
